import lottie from "lottie-web";
import headerLottie from "../../assets/lotties/HSFlogo.json";

import type { AnimationItem } from "lottie-web";
import { isFirefox } from "../utils/variables";
import { inlineUseInsideMasks } from "../utils/inlineUseInsideMasks";

export let headerLotties: AnimationItem[] = [];

export default function initHeaderLogo() {
    const headers = document.querySelectorAll<HTMLElement>(".header");

    headers.forEach(header => {
        const headerLogo = header.querySelector<HTMLElement>(".header__logo");
        if (!headerLogo) return;

        const headerLogoInner = headerLogo.querySelector<HTMLElement>(".header__logo__inner");
        if (!headerLogoInner) return;

        let lottieEl = lottie.loadAnimation({
            container: headerLogoInner,
            animationData: headerLottie,
            renderer: !isFirefox ? "svg" : "canvas",
            loop: false,
            autoplay: false,
        });
        fixLottieRenderingIssues(lottieEl);

        headerLotties.push(lottieEl);
    });
}

function fixLottieRenderingIssues(lottieEl: AnimationItem) {
    setTimeout(() => {
        if (lottieEl.renderer.svgElement) {
            inlineUseInsideMasks(lottieEl.renderer.svgElement);
        }
    }, 10);
}
